var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg093UpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C12.5522 22 13 21.5523 13 21V5.41L18.29 10.71C18.4777 10.8993 18.7333 11.0058 19 11.0058C19.2666 11.0058 19.5222 10.8993 19.71 10.71C19.8993 10.5222 20.0058 10.2666 20.0058 10C20.0058 9.73336 19.8993 9.47777 19.71 9.29L12.71 2.29C12.5222 2.10069 12.2666 1.9942 12 1.9942C11.7333 1.9942 11.4777 2.10069 11.29 2.29L4.28996 9.29C4.03631 9.54366 3.93724 9.91337 4.03009 10.2599C4.12293 10.6064 4.39358 10.877 4.74009 10.9699C5.08659 11.0627 5.45631 10.9637 5.70996 10.71L11 5.41V21C11 21.5523 11.4477 22 12 22Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg093UpArrow);
export default __webpack_public_path__ + "static/media/093-up-arrow.70079a632de84efa235593f84d6c2187.svg";
export { ForwardRef as ReactComponent };